export const ProjectData = [

  {
    id: 1,
    title: 'lafome',
    about: 'Site for training Sass concepts like the use of mixins, include, grid, import and other concepts',
    tags: ['HTML', 'Sass'],
    demo: 'https://nonatodiego.github.io/lafome/',
    github: 'https://github.com/nonatodiego/lafome',
    image: 'https://raw.githubusercontent.com/nonatodiego/lafome/main/design/tablet.png'
  },
  {
    id: 2,
    title: 'Type Game',
    about: 'project to trainnig Js',
    tags: ['HTML', 'JS', 'CSS'],
    demo: 'https://nonatodiego.github.io/type-game/',
    github: 'https://github.com/nonatodiego/type-game',
    image: 'https://raw.githubusercontent.com/nonatodiego/type-game/main/type-game.png'
  },
]